export default __webpack_public_path__ + "static/media/movie.1b239bd0.svg";